export interface Contract {
  contractType: string;
  userId: string;
  signatureStatus: string;
  status: ContractStatus;
  documentVersion: string;
  id: string;
  createdAt: Date;
  updatedAt: Date;
  activatedAt: Date;
  paidAt: Date;
  deactivatedAt: Date;
  signedAt: Date;
  inactiveAt: Date;
  additions: Addition[];
  signedPdfPath: string;
  documentWithProtocolPdfPath: string;
  rawHtmlPath: string;
  rawPdfPath: string;
  activeFrom: Date;
  activeTo: Date;
  expiresAt: Date;
  identityVerifiedAt: Date;
  contractSubNumber: number;
  contractNumber: number;
  contractPrefix: string;
  isPaid: boolean;
  verificationDocumentId: string;
  pepRelatedInformationId: string;
  phoneNumber: string;
  fullName: string;
  giftCode: string;
  packageId: string;
  comments: string[];
  contractPrice: number;
  contractPriceText: string;
  coefficient: number;
  clientType: MemberContractTypes;
}

export interface MemberContract {
  contractId: string;
  contractNumber: string;
  activeFrom: Date;
  activeTo: Date;
  createdAt: Date;
  activatedAt: Date;
  paidAt: Date;
  status: ContractStatus;
  deactivatedAt?: Date;
  additionsSignedAt?: Date;
  signedAt: Date;
  inactiveAt?: Date;
  clientType: MemberContractTypes;
}

export interface Addition {
  documentType: string;
  signatureStatus: string;
  signedPdfPath: string;
  documentWithProtocolPdfPath: string;
  rawHtmlPath: string;
  rawPdfPath: string;
  signedAt: string;
}

export interface PaymentInvoicePayload {
  contractId: string;
  price: number;
  description: string;
}

export enum MemberContractTypes {
  B2B = 'B2B',
  B2C = 'B2C',
}

export enum ContractStatus {
  Draft = 'Draft',
  Active = 'Active',
  Inactive = 'Inactive',
  Rejected = 'Rejected',
  Signed = 'Signed',
  Expired = 'Expired',
}
